import { render, staticRenderFns } from "./scene15.vue?vue&type=template&id=4f8b18f9&scoped=true&"
import script from "./scene15.vue?vue&type=script&lang=ts&"
export * from "./scene15.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b18f9",
  null
  
)

export default component.exports